// https://codepen.io/chriscoyier/pen/WNGQyvX
// https://imagesloaded.desandro.com/#webpack
const imagesLoaded = require('imagesloaded');

function resizeGridItem(item) {
    grid = document.getElementsByClassName("staggered-grid")[0];
    rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
    rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
    rowSpan = Math.ceil((item.querySelector('.recipe-preview').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
    item.style.gridRowEnd = "span " + rowSpan;
}

function resizeAllGridItems() {
    allItems = document.getElementsByClassName("staggered");
    for (x = 0; x < allItems.length; x++) {
        resizeGridItem(allItems[x]);
    }
}

function resizeInstance(instance) {
    item = instance.elements[0];
    resizeGridItem(item);
}

window.onload = resizeAllGridItems();
window.addEventListener("resize", resizeAllGridItems);

allItems = document.getElementsByClassName("staggered");

for (x = 0; x < allItems.length; x++) {
    imagesLoaded(allItems[x], resizeInstance);
}